// extracted by mini-css-extract-plugin
export var indeterminate = "_40-6";
export var md = "_40-5";
export var semantic = "_40-7";
export var sm = "_40-4";
export var text = "_40-8";
export var toggleControl = "_40-0";
export var toggleInput = "_40-1";
export var toggleSwitch = "_40-2";
export var xs = "_40-3";